import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import "./selectArticles.css";
import Article from "./Article";
import Category from "./Category";
import { obj } from "pumpify";

import {
  getTemplate,
  getCats,
  getArticles,
} from "components/Vestorly/Vestorly";

import $ from "jquery";
const SelectArticles = (props) => {
  const [onCategories, setOnCategories] = useState(false);
  const [hide, setHide] = useState(false);
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [chosenC, setChosenC] = useState("");
  const [selectedArticlesCount, setselectedArticlesCount] = useState(0);
  const [selectedArticles, setselectedArticles] = useState([]);

  //let selectedArticles = [];

  useEffect(() => {
    // getCats()
    //   .then((data) => {
    //     setCategories(data.custom_feeds);
    //   })
    //   .catch((e) => { })
    window.onbeforeunload = function () {
      let all = "";
      props.block().replaceWith(all);
    };
    getBlogs()
  }, []);
  function hideVistorlyView() {
    let all = "";
    props.block().replaceWith(all);
    setselectedArticles([]);
    if (document.getElementById("vestorlyWindow")) {
      document.getElementById("vestorlyWindow").style.display = "none";
      document.getElementById("cover").style.display = "none";
    }
    // setOnCategories(true);
    // setArticles([]);
  }

  function handleSelect(ind) {
    let aa = [...selectedArticles];
    //
    let f = false;
    let newA = [];
    aa.forEach((a) => {
      if (a != ind) newA.push(a);
      else f = true;
    });
    if (!f) newA.push(ind);
    setselectedArticles(newA);

    // if (f) {
    //   let newA = []
    //   selectedArticles.forEach(a =>{
    //     if(a!=ind)
    //       newA.push(a);
    //   })
    //   selectedArticles = newA;
    //   setselectedArticlesCount(selectedArticles.length);
    //   
    //   return;
    // }else{

    //   selectedArticles.push(ind);

    //   setselectedArticlesCount(selectedArticles.length);
    //   
    // }
  }

  function getBlogs(){
        getArticles()
      .then((data) => {
        console.log(data)
        setArticles(data);
      })
      .catch((e) => { })
  }
  function handleSelectCategory(ind) {
    let chosen = categories[ind];
    // getArticles(chosen._id)
    //   .then((data) => {
    //     setArticles(data.articles);
    //   })
    //   .catch((e) => { })
    // setChosenC(chosen);

    // setOnCategories(false);
  }

  function addArticles() {
    let all = "";
    selectedArticles.forEach((i) => {
      all += getTemplate(articles[i], props.type());
    });
    props.block().replaceWith(all);
    setselectedArticles([]);
    if (document.getElementById("vestorlyWindow")) {
      document.getElementById("vestorlyWindow").style.display = "none";
      document.getElementById("cover").style.display = "none";
    }
    // setOnCategories(true);
    setselectedArticles([]);

    $('.Vlabel input:checkbox').removeAttr('checked');
    console.log( $('.Vlabel input:checkbox'))

    let temp = [...articles]
    setArticles(temp)
  }

  return (
    <>
      <div id="mydiv2" style={hide ? { display: "none" } : {}}>
        <h6
          className="close"
          onClick={() => {
            hideVistorlyView();
          }}
        >
          x
        </h6>

        {/*                 
               // {onCategories ?  */}
        <h4 class="Vtitle">
          {onCategories ? "All Categories" : chosenC.label}
        </h4>

        <div
          class="Vcontainer"
          style={{
            overflowY: "scroll",
            height: "533px",
            paddingTop: "10px",
          }}
        >
          {onCategories
            ? categories.map((obj, ind) => {
              return (
                <Category
                  cat={obj}
                  ind={ind}
                  handleSelect={handleSelectCategory}
                />
              );
            })
            : articles.map((obj, ind) => {
              return (
                <Article
                  article={obj}
                  ind={ind}
                  handleSelect={handleSelect}
                />
              );
            })}
        </div>
        <input
            type="submit"
            name="Save"
            id='profilel'
            style={{ cursor: "pointer" }}
            className="lg_btn secondary mb-2"
            value="Cancel"
            onClick={hideVistorlyView}
          />

        {!onCategories ? (
          <input
            type="submit"
            name="Save"
            disabled={selectedArticles.length > 0 ? false : true}
            style={{ cursor: "pointer" }}
            className="lg_btn secondary mb-2"
            id={selectedArticles.length > 0 ? "profile2" : "dis"}
            value="Continue"
            onClick={addArticles}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default SelectArticles;
